import styles from "./divider.module.css";

function Divider(props) {
  return <hr className={props.contained ? styles.contained : styles.full}></hr>;
}

export default Divider;
